// SPDX-License-Identifier: FSL-1.1-Apache-2.0
/**
 * @module cx
 * @package @geenius/analytics/react-css
 * @description Provides the vanilla-CSS class-name combiner used by the
 * React CSS variant so component markup can compose stable stylesheet classes
 * without depending on Tailwind-specific helpers.
 */

/**
 * Joins truthy class-name fragments into a single space-delimited string.
 *
 * @param classes Candidate class-name fragments that may be falsy.
 * @returns The composed class-name string for the rendered element.
 *
 * @example
 * ```ts
 * const classes = cx('gn-analytics-card', isActive && 'gn-analytics-card--active')
 * ```
 */
export function cx(
  ...classes: Array<string | false | null | undefined>
): string {
  return classes.filter(Boolean).join(" ");
}
